import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/events.action';
import { switchMap, map, catchError, withLatestFrom, tap } from 'rxjs/operators';
import { EventService } from '../../services';
import { Go } from 'src/app/store';
import { getEventsPage } from '../selectors';
import { Store } from '@ngrx/store';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UrlRewritePipe } from '@teamfoster/sdk/text-utility';

export const LoadEventsItems$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadEvents),
      switchMap(() =>
        service.getEvents().pipe(
          map(events => actions.LoadEventsSuccess({ events })),
          catchError(error => of(actions.LoadEventsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadEventsOverview$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadEventsOverview),
      switchMap(({ skip, take, filters }) =>
        service.getEventsOverview(skip, take, filters).pipe(
          map(events => actions.LoadEventsOverviewSuccess({ events })),
          catchError(error => of(actions.LoadEventsOverviewFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadMoreEvents$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(actions.LoadMoreEvents),
      withLatestFrom(store.select(getEventsPage)),
      switchMap(([{}, page]) =>
        service.getEventsOverview((page.currentPage + 1) * page.pageSize, page.pageSize, page.filters).pipe(
          map(events => actions.LoadMoreEventsSuccess({ events })),
          catchError(error => of(actions.LoadEventsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadEventsById$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadEventById),
      switchMap(({ id, eventDate }) =>
        service.getEventById(id, eventDate).pipe(
          map(item => actions.LoadEventByIdSuccess({ item })),
          catchError(error => of(actions.LoadEventByIdFail({ id, error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadEventsByIdSuccess$ = createEffect(
  (actions$ = inject(Actions), router = inject(Router), route = inject(ActivatedRoute)) => {
    var datePipe = new DatePipe('nl_NL');
    var urlRewritePipe = new UrlRewritePipe();
    return actions$.pipe(
      ofType(actions.LoadEventByIdSuccess),
      tap(({ item }) => {
        const eventDate = route.snapshot.params['eventDate'];
        if (!eventDate) {
          router.navigate(['/agenda', item.id, datePipe.transform(item.startDate, 'dd-MM-yyyy'), urlRewritePipe.transform(item.title)]);
        }
      })
    );
  },
  { functional: true, dispatch: false }
);

export const LoadEventsByIdFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadEventByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);
